import { StateEnum } from "../../../Models/Bases/StateEnum";
import { BaseService } from "../../Bases/BaseService";
import { ValidationResponse } from "../../Bases/ValidationResponse";

export class UsuarioPainelService extends BaseService {
    public selecionarValidos(usuarioPaineis: any) {
        return usuarioPaineis?.filter((e: any) => e.state != StateEnum.Deleted) ?? [];
    }

    public salvar(usuarioPainel: any, usuarioPaineis: any) {
        if (usuarioPainel.nome_painel=='' ||
            usuarioPainel.url_painel=='') {
            return new ValidationResponse(null, 'Preencha os campos obrigatórios!');
        }

        let validation = usuarioPaineis?.filter(
            (e: any) =>
                usuarioPainel.id != e.id &&
                usuarioPainel.nome_painel == e.nome_painel &&
                usuarioPainel.url_painel == e.url_painel &&
                e.state != StateEnum.Deleted);

        if (validation.length > 0) {
            return new ValidationResponse(null, 'Painel já inserido!');
        }

        if (usuarioPainel.id == 0) {
            let ids = usuarioPaineis?.map((x: any) => x.id) ?? [];
            let min = Math.min.apply(null, ids);
            usuarioPainel.id = min > 0 ? -1 : min - 1; //isNaN(min) || 
            usuarioPainel.state = StateEnum.Inserted;
            usuarioPaineis = usuarioPaineis.concat(usuarioPainel);
        }
        else {
            usuarioPainel.state = usuarioPainel.state == StateEnum.Inserted ? StateEnum.Inserted : StateEnum.Updated;
            var index = usuarioPaineis.map(function(x:any) {return x.id; }).indexOf(usuarioPainel.id);
            usuarioPaineis[index] = usuarioPainel;
        }

        return new ValidationResponse(usuarioPaineis);
    }

    public apagar(id: number, usuarioPaineis: any) {
        if (id > 0) {
            usuarioPaineis.forEach((e: any) => e.state = (e.id == id ? StateEnum.Deleted : e.state));
        }
        else {
            usuarioPaineis = usuarioPaineis?.filter((e: any) => e.id != id);
        }

        return new ValidationResponse(usuarioPaineis);
    }
}